module.exports = __webpack_public_path__ + "img/huayang1.efef3f97.png";